import { API_FILES_HEADERS, API_HEADERS, liferayConfig } from "./utils";

class DossierService {
    constructor() {
        this.liferayConfig = liferayConfig;
        this.nwHeaders = API_HEADERS;
        this.flHeadears = API_FILES_HEADERS;
    }

    async allDossierSectionsNumber(code) {
        try {

            const url = `${this.liferayConfig.baseUrl}/o/c/dossiers/${code}/dossierSection?fields=totalCount`;
            const response = await fetch(url, {
                method: 'GET',
                headers: this.nwHeaders
            });

            const data = await response.json();
            if (data.totalCount === 0) {
                return [];
            }
            return data.totalCount || 0;
        } catch (error) {
            console.error('Error fetching affaires:', error);
            return 0;
        }
    }

    async numberDossierSectionsComplete(code) {
        let total = 0;
        try {

            const sections = await this.allDossierSections(code);
            sections.forEach(section => {
                if (section.complete) {
                    total++;
                }
            });
            return total;
        } catch (error) {
            console.log("🚀 ~ DossierService ~ numberDossierSectionsComplete ~ error:", error)
            return total;
        }
    }

    async allDossierSections(code) {
        try {

            const url = `${this.liferayConfig.baseUrl}/o/c/dossiers/${code}/dossierSection?nestedFields=r_sectionStatusDossier_c_sectioneId,`;
            const response = await fetch(url, {
                method: 'GET',
                headers: this.nwHeaders
            });

            const data = await response.json();
            if (data.totalCount === 0) {
                return [];
            }
            return data.items || [];
        } catch (error) {
            console.error('Error fetching affaires:', error);
            return [];
        }
    }

    async allSectionDossier(id) {
        try {
            const url = `${this.liferayConfig.baseUrl}/o/c/sectiondossiers/${id}/sectionDossier?nestedFields=r_attributSection_c_attributId,attributSection,sectionDossier`;
            const response = await fetch(url, {
                method: 'GET',
                headers: this.nwHeaders
            });

            const data = await response.json();
            return data.items || [];

        } catch (error) {
            console.error('Error fetching affaires:', error);
            return [];
        }
    }
}
export default DossierService;